export const cities = [
  // 🌆 Middle East
  {
    id: 1,
    name: "Dubai",
    slug:"dubai",
    country: "UAE",
    desc: "A dazzling metropolis where innovation meets tradition.",
    image: "https://images.unsplash.com/flagged/photo-1559717865-a99cac1c95d8?w=1000&auto=format&fit=crop&q=60&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxzZWFyY2h8NHx8ZHViYWl8ZW58MHx8MHx8fDA%3D",
  },
  {
    id: 2,
    name: "Istanbul",
    slug:"istanbul",
    country: "Turkey",
    desc: "A city bridging continents and centuries of history.",
    image: "https://images.unsplash.com/photo-1527838832700-5059252407fa?w=1200",
  },

  // 🌏 Asia
  {
    id: 3,
    name: "Hong Kong",
    slug:"hong-kong",
    country: "China",
    desc: "A vibrant skyline where East meets West.",
    image: "https://images.unsplash.com/photo-1616394158624-a2ba9cfe2994?w=1000&auto=format&fit=crop&q=60&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxzZWFyY2h8NHx8aG9uZyUyMGtvbmd8ZW58MHx8MHx8fDA%3D",
  },
  {
    id: 4,
    name: "Tokyo",
    slug:"tokyo",

    country: "Japan",
    desc: "A futuristic city rooted in ancient traditions.",
    image: "https://plus.unsplash.com/premium_photo-1661902398022-762e88ff3f82?w=1000&auto=format&fit=crop&q=60&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxzZWFyY2h8NXx8dG9reW98ZW58MHx8MHx8fDA%3D",
  },
  {
    id: 5,
    name: "Seoul",
    slug :"seoul",
    country: "South Korea",
    desc: "K-culture, street food, and high-tech city life.",
    image: "https://images.unsplash.com/photo-1549693578-d683be217e58?w=1200",
  },
  {
    id: 6,
    name: "Bangkok",
    slug:"bangkok",
    country: "Thailand",
    desc: "Temples, street food, and vibrant nightlife.",
    image: "https://images.unsplash.com/photo-1508009603885-50cf7c579365?w=1200",
  },
  {
    id: 7,
    name: "Singapore",
    slug:"singapore",
    country: "Singapore",
    desc: "A clean, modern city with rich multicultural roots.",
    image: "https://images.unsplash.com/photo-1508964942454-1a56651d54ac?w=1200",
  },

  // 🇮🇳 India
  {
    id: 8,
    name: "Delhi",
    slug:"delhi",
    country: "India",
    desc: "A capital city layered with history and culture.",
    image: "https://images.unsplash.com/photo-1597040663342-45b6af3d91a5?w=1200",
  },
  {
    id: 9,
    name: "Mumbai",
    slug :"mumbai",
    country: "India",
    desc: "India’s financial hub with unstoppable energy.",
    image: "https://images.unsplash.com/photo-1570168007204-dfb528c6958f?w=1200",
  },
  {
    id: 10,
    name: "Jaipur",
    slug :"jaipur",
    country: "India",
    desc: "The Pink City of royal palaces and forts.",
    image: "https://images.unsplash.com/photo-1603262110263-fb0112e7cc33?w=1000&auto=format&fit=crop&q=60&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxzZWFyY2h8Mnx8amFpcHVyfGVufDB8fDB8fHww",
  },

  // 🇪🇺 Europe
  {
    id: 11,
    name: "London",
    slug :"london",
    country: "UK",
    desc: "Historic charm blended with modern energy.",
    image:"https://images.unsplash.com/photo-1526129318478-62ed807ebdf9?q=80&w=987&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",
  },
  {
    id: 12,
    name: "Paris",
    slug :"paris",
    country: "France",
    desc: "Romance, art, fashion, and iconic landmarks.",
    image: "https://images.unsplash.com/photo-1522093007474-d86e9bf7ba6f?w=1000&auto=format&fit=crop&q=60&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxzZWFyY2h8MTF8fHBhcmlzfGVufDB8fDB8fHww",
  },
  {
    id: 13,
    name: "Rome",
    slug :"rome",
    country: "Italy",
    desc: "An open-air museum of ancient civilization.",
    image: "https://images.unsplash.com/photo-1531572753322-ad063cecc140?w=1000&auto=format&fit=crop&q=60&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxzZWFyY2h8M3x8cm9tZXxlbnwwfHwwfHx8MA%3D%3D",
  },
  {
    id: 14,
    name: "Barcelona",
    slug :"barcelona",
    country: "Spain",
    desc: "Beaches, architecture, and artistic soul.",
    image: "https://images.unsplash.com/photo-1564221710304-0b37c8b9d729?w=1000&auto=format&fit=crop&q=60&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxzZWFyY2h8MTV8fGJhcmNlbG9uYXxlbnwwfHwwfHx8MA%3D%3D",
  },
  {
    id: 15,
    name: "Amsterdam",
    slug :"amsterdam",
    country: "Netherlands",
    desc: "Canals, bicycles, and creative culture.",
    image: "https://plus.unsplash.com/premium_photo-1661887237533-b38811c27add?w=1000&auto=format&fit=crop&q=60&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxzZWFyY2h8MXx8YW1zdGVyZGFtfGVufDB8fDB8fHww",
  },

  // 🌎 Americas
  {
    id: 16,
    name: "New York City",
    slug :"new-york-city",
    country: "USA",
    desc: "The city that never sleeps.",
    image: "https://images.unsplash.com/photo-1485871981521-5b1fd3805eee?w=1000&auto=format&fit=crop&q=60&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxzZWFyY2h8M3x8bmV3JTIweW9ya3xlbnwwfHwwfHx8MA%3D%3D",
  },
  {
    id: 17,
    name: "Los Angeles",
    slug :"los-angeles",
    country: "USA",
    desc: "The entertainment capital with endless diversity.",
    image: "https://images.unsplash.com/photo-1580655653885-65763b2597d0?w=1000&auto=format&fit=crop&q=60&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxzZWFyY2h8M3x8bG9zJTIwYW5nZWxlc3xlbnwwfHwwfHx8MA%3D%3D",
  },
  {
    id: 18,
    name: "Rio de Janeiro",
    slug: "rio-de-janeiro",
    country: "Brazil",
    desc: "Beaches, mountains, and carnival spirit.",
    image: "https://images.unsplash.com/photo-1626568941852-70bc179e493e?w=1000&auto=format&fit=crop&q=60&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxzZWFyY2h8N3x8cmlvJTIwZGUlMjBqYW5laXJvfGVufDB8fDB8fHww",
  },
  {
    id: 19,
    name: "Buenos Aires",
    slug :"buenos-aires",
    country: "Argentina",
    desc: "European elegance with Latin passion.",
    image: "https://images.unsplash.com/photo-1610135206707-0f03e4800631?w=1000&auto=format&fit=crop&q=60&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxzZWFyY2h8NHx8YnVlbm9zJTIwYWlyZXN8ZW58MHx8MHx8fDA%3D",
  },

  // 🌍 Africa
  {
    id: 20,
    name: "Cape Town",
    slug :"cape-town",
    country: "South Africa",
    desc: "Mountains, beaches, and dramatic landscapes.",
    image: "https://images.unsplash.com/photo-1576485290814-1c72aa4bbb8e?w=1000&auto=format&fit=crop&q=60&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxzZWFyY2h8M3x8Y2FwZSUyMHRvd258ZW58MHx8MHx8fDA%3D",
  },
  {
    id: 21,
    name: "Marrakech",
    slug:"marrakech",
    country: "Morocco",
    desc: "Colorful souks and ancient medinas.",
    image: "https://images.unsplash.com/photo-1587974928442-77dc3e0dba72?w=1000&auto=format&fit=crop&q=60&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxzZWFyY2h8NHx8bWFycmFrZWNofGVufDB8fDB8fHww",
  },

  // 🌊 Oceania
  {
    id: 22,
    name: "Sydney",
    slug:"sydney",
    country: "Australia",
    desc: "Iconic harbor, beaches, and vibrant lifestyle.",
    image: "https://images.unsplash.com/photo-1624138784614-87fd1b6528f8?w=1000&auto=format&fit=crop&q=60&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxzZWFyY2h8N3x8c3lkbmV5fGVufDB8fDB8fHww",
  },
  {
    id: 23,
    name: "Melbourne",
    slug:"melbourne",
    country: "Australia",
    desc: "Culture, coffee, art, and coastal beauty.",
    image: "https://images.unsplash.com/photo-1546868762-b61266729c8a?w=1000&auto=format&fit=crop&q=60&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxzZWFyY2h8MTB8fG1lbGJvdXJuZXxlbnwwfHwwfHx8MA%3D%3D",
  },
  {
    id: 24,
    name: "Auckland",
    slug:"auckland",
    country: "New Zealand",
    desc: "Nature-rich city between two harbors.",
    image: "https://images.unsplash.com/photo-1507699622108-4be3abd695ad?w=1000&auto=format&fit=crop&q=60&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxzZWFyY2h8NHx8YXVja2xhbmR8ZW58MHx8MHx8fDA%3D",
  },
  {
  id: 25,
  name: "Berlin",
  slug:"berlin",
  country: "Germany",
  desc: "A creative capital shaped by history and modern culture.",
  image: "https://plus.unsplash.com/premium_photo-1694475085892-3bb718a2bc05?w=1000&auto=format&fit=crop&q=60&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxzZWFyY2h8NXx8YmVybGlufGVufDB8fDB8fHww",
},
{
  id: 26,
  name: "Vienna",
  slug:"vienna",
  country: "Austria",
  desc: "Classical music, imperial palaces, and timeless elegance.",
  image: "https://images.unsplash.com/photo-1573167443175-867d91708f97?w=1000&auto=format&fit=crop&q=60&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxzZWFyY2h8Nnx8dmllbm5hfGVufDB8fDB8fHww",
},
{
  id: 27,
  name: "Prague",
  slug:"prague",
  country: "Czech Republic",
  desc: "A fairytale city of castles, bridges, and medieval streets.",
  image: "https://images.unsplash.com/photo-1600623471616-8c1966c91ff6?w=1000&auto=format&fit=crop&q=60&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxzZWFyY2h8NHx8cHJhZ3VlfGVufDB8fDB8fHww",
},
{
  id: 28,
  name: "Budapest",
  slug:"budapest",
  country: "Hungary",
  desc: "Thermal baths, grand architecture, and nightlife.",
  image: "https://images.unsplash.com/photo-1541343672885-9be56236302a?w=1000&auto=format&fit=crop&q=60&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxzZWFyY2h8Mnx8YnVkYXBlc3R8ZW58MHx8MHx8fDA%3D",
},
{
  id: 29,
  name: "Lisbon",
  slug:"lisbon",
  country: "Portugal",
  desc: "Colorful streets, trams, and Atlantic charm.",
  image: "https://images.unsplash.com/photo-1585208798174-6cedd86e019a?w=1000&auto=format&fit=crop&q=60&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxzZWFyY2h8Mnx8bGlzYm9ufGVufDB8fDB8fHww",
},
{
  id: 30,
  name: "Zurich",
  slug:"zurich",
  country: "Switzerland",
  desc: "Lakeside beauty with alpine precision.",
  image: "https://images.unsplash.com/photo-1620563316910-f242d1bad656?w=1000&auto=format&fit=crop&q=60&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxzZWFyY2h8N3x8enVyaWNofGVufDB8fDB8fHww",
},
{
  id: 31,
  name: "Athens",
  slug:"athens",
  country: "Greece",
  desc: "Ancient ruins and Mediterranean life.",
  image: "https://images.unsplash.com/photo-1602769247692-126fdf1f1da6?w=1000&auto=format&fit=crop&q=60&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxzZWFyY2h8Nnx8YXRoZW5zfGVufDB8fDB8fHww",
},
{
  id: 32,
  name: "Copenhagen",
  slug:"copenhagen",
  country: "Denmark",
  desc: "Design-forward living with cozy hygge vibes.",
  image: "https://images.unsplash.com/photo-1513622118278-bc041b3c13ed?w=1000&auto=format&fit=crop&q=60&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxzZWFyY2h8NHx8Y29wZW5oYWdlbnxlbnwwfHwwfHx8MA%3D%3D",
},
{
  id: 33,
  name: "Stockholm",
  slug:"stockholm",
  country: "Sweden",
  desc: "Scandinavian elegance across islands.",
  image: "https://images.unsplash.com/photo-1600290601473-3b73e4c531c9?w=1000&auto=format&fit=crop&q=60&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxzZWFyY2h8N3x8c3RvY2tob2xtfGVufDB8fDB8fHww",
},
{
  id: 34,
  name: "Oslo",
  slug:"oslo",
  country: "Norway",
  desc: "Nature meets modern Nordic architecture.",
  image: "https://images.unsplash.com/photo-1560525942-fca0ea0acade?w=1000&auto=format&fit=crop&q=60&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxzZWFyY2h8OHx8b3Nsb3xlbnwwfHwwfHx8MA%3D%3D",
},
{
  id: 35,
  name: "Helsinki",
  slug:"helsinki",
  country: "Finland",
  desc: "Minimal design, saunas, and coastal calm.",
  image: "https://images.unsplash.com/photo-1538332576228-eb5b4c4de6f5?w=1000&auto=format&fit=crop&q=60&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxzZWFyY2h8Mnx8aGVsc2lua2l8ZW58MHx8MHx8fDA%3D",
},
{
  id: 36,
  name: "Edinburgh",
  slug:"edinburgh",
  country: "Scotland",
  desc: "Castles, cobbled streets, and literary soul.",
  image: "https://images.unsplash.com/photo-1506377585622-bedcbb027afc?w=1000&auto=format&fit=crop&q=60&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxzZWFyY2h8Mnx8ZWRpbmJ1cmdofGVufDB8fDB8fHww",
},
{
  id: 37,
  name: "Venice",
  slug:"venice",
  country: "Italy",
  desc: "Canals, gondolas, and timeless romance.",
  image: "https://images.unsplash.com/photo-1519112232436-9923c6ba3d26?w=1000&auto=format&fit=crop&q=60&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxzZWFyY2h8Nnx8dmVuaWNlfGVufDB8fDB8fHww",
},
{
  id: 38,
  name: "Florence",
  slug:"florence",
  country: "Italy",
  desc: "Renaissance art and Tuscan charm.",
  image: "https://images.unsplash.com/photo-1476362174823-3a23f4aa6d76?w=1000&auto=format&fit=crop&q=60&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxzZWFyY2h8Mnx8ZmxvcmVuY2V8ZW58MHx8MHx8fDA%3D",
},
{
  id: 39,
  name: "Madrid",
  slug:"madrid",
  country: "Spain",
  desc: "Royal heritage, nightlife, and food culture.",
  image: "https://images.unsplash.com/photo-1574556462575-eb106a5865a0?w=1000&auto=format&fit=crop&q=60&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxzZWFyY2h8N3x8bWFkcmlkfGVufDB8fDB8fHww",
},
{
  id: 40,
  name: "Seville",
  slug:"seville",
  country: "Spain",
  desc: "Flamenco, Moorish architecture, and orange trees.",
  image: "https://plus.unsplash.com/premium_photo-1697729598906-fd57243037e3?w=1000&auto=format&fit=crop&q=60&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxzZWFyY2h8NXx8c2V2aWxsZXxlbnwwfHwwfHx8MA%3D%3D",
},
{
  id: 41,
  name: "Warsaw",
  slug:"warsaw",
  country: "Poland",
  desc: "Resilient history with modern energy.",
  image: "https://plus.unsplash.com/premium_photo-1688901653255-88753dbcb6ba?w=1000&auto=format&fit=crop&q=60&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxzZWFyY2h8MTN8fHdhcnNhd3xlbnwwfHwwfHx8MA%3D%3D",
},
{
  id: 42,
  name: "Krakow",
  slug:"krakow",
  country: "Poland",
  desc: "Medieval squares and deep cultural roots.",
  image: "https://images.unsplash.com/photo-1519922639192-e73293ca430e?w=1000&auto=format&fit=crop&q=60&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxzZWFyY2h8MTV8fGtyYWtvd3xlbnwwfHwwfHx8MA%3D%3D",
},
{
  id: 43,
  name: "Tallinn",
  slug:"tallinn",
  country: "Estonia",
  desc: "One of Europe’s best-preserved old towns.",
  image: "https://images.unsplash.com/photo-1452868195396-89c1af3b1b2e?w=1000&auto=format&fit=crop&q=60&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxzZWFyY2h8NHx8dGFsbGlubnxlbnwwfHwwfHx8MA%3D%3D",
},
{
  id: 44,
  name: "Riga",
  slug:"riga",
  country: "Latvia",
  desc: "Art Nouveau architecture and Baltic charm.",
  image: "https://images.unsplash.com/photo-1614887259709-fe2c3aa56022?q=80&w=1074&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",
},
{
  id: 45,
  name: "Vilnius",
  slug:"vilnius",
  country: "Lithuania",
  desc: "Baroque beauty with creative spirit.",
  image: "https://images.unsplash.com/photo-1578845832207-b74a206ac25d?w=1000&auto=format&fit=crop&q=60&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxzZWFyY2h8M3x8dmlsbml1c3xlbnwwfHwwfHx8MA%3D%3D",
},
{
  id: 46,
  name: "Reykjavik",
  slug:"reykjavik",
  country: "Iceland",
  desc: "Gateway to volcanoes, glaciers, and auroras.",
  image: "https://images.unsplash.com/photo-1465353471565-b77e538f34c9?w=1000&auto=format&fit=crop&q=60&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxzZWFyY2h8Nnx8cmV5a2phdmlrfGVufDB8fDB8fHww",
},
{
  id: 47,
  name: "Moscow",
  slug:"moscow",
  country: "Russia",
  desc: "Grand architecture and deep history.",
  image: "https://images.unsplash.com/photo-1513326738677-b964603b136d?w=1000&auto=format&fit=crop&q=60&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxzZWFyY2h8Mnx8bW9zY293fGVufDB8fDB8fHww",
},
{
  id: 48,
  name: "St. Petersburg",
  slug:"st-petersburg",
  country: "Russia",
  desc: "Imperial canals and artistic heritage.",
  image: "https://images.unsplash.com/photo-1556543697-b40fdaadca4d?w=1000&auto=format&fit=crop&q=60&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxzZWFyY2h8Mnx8c3QlMjBwZXRlcnNidXJnfGVufDB8fDB8fHww",
},
{
  id: 49,
  name: "Dublin",
  slug:"dublin",
  country: "Ireland",
  desc: "Lively pubs, literature, and coastal charm.",
  image: "https://images.unsplash.com/photo-1549918864-48ac978761a4?w=1000&auto=format&fit=crop&q=60&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxzZWFyY2h8Mnx8ZHVibGlufGVufDB8fDB8fHww",
},
{
  id: 50,
  name: "Brussels",
  slug:"brussels",
  country: "Belgium",
  desc: "Chocolate, waffles, and European culture.",
  image: "https://images.unsplash.com/photo-1548092304-e0205cb0031b?w=1000&auto=format&fit=crop&q=60&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxzZWFyY2h8Mnx8YnJ1c3NlbHN8ZW58MHx8MHx8fDA%3D",
},
{
  id: 51,
  name: "Nagoya",
  slug:"nagoya",
  country: "Japan",
  desc: "A futuristic megacity rooted in tradition.",
  image: "https://images.unsplash.com/photo-1596628889205-f92ba59fd2ba?w=1000&auto=format&fit=crop&q=60&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxzZWFyY2h8M3x8bmFnb3lhfGVufDB8fDB8fHww",
},
{
  id: 52,
  name: "Kyoto",
  slug:"kyoto",
  country: "Japan",
  desc: "Ancient temples, geishas, and cherry blossoms.",
  image: "https://images.unsplash.com/photo-1493976040374-85c8e12f0c0e?w=1000&auto=format&fit=crop&q=60&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxzZWFyY2h8Mnx8a3lvdG98ZW58MHx8MHx8fDA%3D",
},
{
  id: 53,
  name: "Busan",
  slug:"busan",
  country: "South Korea",
  desc: "K-pop culture meets historic palaces.",
  image: "https://images.unsplash.com/photo-1591520284162-8e64eceebacf?w=1000&auto=format&fit=crop&q=60&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxzZWFyY2h8M3x8YnVzYW58ZW58MHx8MHx8fDA%3D",
},
{
  id: 54,
  name: "Pattaya",
  slug:"pattaya",
  country: "Thailand",
  desc: "Street food, temples, and vibrant nightlife.",
  image: "https://images.unsplash.com/photo-1503788311183-fa3bf9c4bc32?w=1000&auto=format&fit=crop&q=60&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxzZWFyY2h8NHx8cGF0dGF5YXxlbnwwfHwwfHx8MA%3D%3D",
},
{
  id: 55,
  name: "Singapore",
  slug:"singapore",
  country: "Singapore",
  desc: "A clean, modern city with global flavors.",
  image: "https://images.unsplash.com/photo-1525625293386-3f8f99389edd?w=1000&auto=format&fit=crop&q=60&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxzZWFyY2h8M3x8c2luZ2Fwb3JlfGVufDB8fDB8fHww",
},
{
  id: 56,
  name: "Kuala Lumpur",
  slug:"kuala-lumpur",
  country: "Malaysia",
  desc: "Skyscrapers rising above cultural heritage.",
  image: "https://images.unsplash.com/photo-1596422846543-75c6fc197f07?w=1000&auto=format&fit=crop&q=60&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxzZWFyY2h8Mnx8a3VhbGElMjBsdW1wdXJ8ZW58MHx8MHx8fDA%3D",
},
{
  id: 57,
  name: "Bali",
  slug :"bali",
  country: "Indonesia",
  desc: "Tropical paradise of temples and beaches.",
  image: "https://plus.unsplash.com/premium_photo-1677829177642-30def98b0963?w=1000&auto=format&fit=crop&q=60&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxzZWFyY2h8MXx8YmFsaXxlbnwwfHwwfHx8MA%3D%3D",
},
{
  id: 58,
  name: "Jakarta",
  slug:"jakarta",
  country: "Indonesia",
  desc: "A fast-paced capital with diverse cultures.",
  image: "https://images.unsplash.com/photo-1567756396406-f529ebb5583d?w=1000&auto=format&fit=crop&q=60&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxzZWFyY2h8OHx8amFrYXJ0YXxlbnwwfHwwfHx8MA%3D%3D",
},
{
  id: 59,
  name: "Hanoi",
  slug:"hanoi",
  country: "Vietnam",
  desc: "Historic streets and rich street-food culture.",
  image: "https://images.unsplash.com/photo-1555921015-5532091f6026?w=1000&auto=format&fit=crop&q=60&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxzZWFyY2h8Mnx8aGFub2l8ZW58MHx8MHx8fDA%3D",
},
{
  id: 60,
  name: "Ho Chi Minh City",
  slug:"ho-chi-minh",
  country: "Vietnam",
  desc: "Dynamic city blending past and present.",
  image: "https://images.unsplash.com/photo-1580835267732-2d232d3d2655?w=1000&auto=format&fit=crop&q=60&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxzZWFyY2h8MTJ8fGhvJTIwY2hpJTIwbWluaCUyMGNpdHl8ZW58MHx8MHx8fDA%3D",
},
{
  id: 61,
  name: "Beijing",
  slug:"beijing",
  country: "China",
  desc: "Imperial history and modern transformation.",
  image: "https://images.unsplash.com/photo-1584872589930-e99fe5bf4408?w=1000&auto=format&fit=crop&q=60&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxzZWFyY2h8Mnx8YmVpamluZ3xlbnwwfHwwfHx8MA%3D%3D",
},
{
  id: 62,
  name: "Shanghai",
  slug:"shanghai",
  country: "China",
  desc: "China’s global financial and cultural hub.",
  image: "https://images.unsplash.com/photo-1627484986972-e544190b8abb?w=1000&auto=format&fit=crop&q=60&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxzZWFyY2h8NHx8c2hhbmdoYWl8ZW58MHx8MHx8fDA%3D",
},
{
  id: 63,
  name: "Taipei",
  slug:"taipei",
  country: "Taiwan",
  desc: "Night markets, mountains, and modern life.",
  image: "https://images.unsplash.com/photo-1572715381359-002b1eabd56b?w=1000&auto=format&fit=crop&q=60&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxzZWFyY2h8Mnx8dGFpcGVpfGVufDB8fDB8fHww",
},
{
  id: 64,
  name: "Manila",
  slug:"manila",
  country: "Philippines",
  desc: "Historic districts and island energy.",
  image: "https://images.unsplash.com/photo-1655016268120-383558788b37?w=1000&auto=format&fit=crop&q=60&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxzZWFyY2h8Nnx8bWFuaWxhfGVufDB8fDB8fHww",
},
{
  id: 65,
  name: "Colombo",
  slug:"colombo",
  country: "Sri Lanka",
  desc: "Coastal capital with colonial influences.",
  image: "https://images.unsplash.com/photo-1704797390767-de3e63fa939f?w=1000&auto=format&fit=crop&q=60&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxzZWFyY2h8NHx8Y29sb21ib3xlbnwwfHwwfHx8MA%3D%3D",
},
{
  id: 66,
  name: "Kathmandu",
  slug:"kathmandu",
  country: "Nepal",
  desc: "Gateway to the Himalayas and spiritual heritage.",
  image: "https://images.unsplash.com/photo-1605640840605-14ac1855827b?w=1000&auto=format&fit=crop&q=60&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxzZWFyY2h8Mnx8a2F0aG1hbmR1fGVufDB8fDB8fHww",
},
{
  id: 67,
  name: "Thimphu",
  slug:"thimphu",
  country: "Bhutan",
  desc: "Peaceful capital rooted in tradition.",
  image: "https://images.unsplash.com/photo-1665479003896-6d1c61af635c?w=1000&auto=format&fit=crop&q=60&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxzZWFyY2h8Nnx8dGhpbXBodXxlbnwwfHwwfHx8MA%3D%3D",
},
{
  id: 68,
  name: "Ulaanbaatar",
  slug:"ulaanbaatar",
  country: "Mongolia",
  desc: "Nomadic culture meets urban life.",
  image: "https://images.unsplash.com/photo-1708873395735-dcad0140e3a2?w=1000&auto=format&fit=crop&q=60&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxzZWFyY2h8NHx8dWxhYW5iYWF0YXJ8ZW58MHx8MHx8fDA%3D",
},
{
  id: 69,
  name: "Tashkent",
  slug:"tashkent",
  country: "Uzbekistan",
  desc: "Silk Road history with Soviet-era charm.",
  image: "https://images.unsplash.com/photo-1622021109028-8ba1d5374161?w=1000&auto=format&fit=crop&q=60&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxzZWFyY2h8Mnx8dGFzaGtlbnR8ZW58MHx8MHx8fDA%3D",
},
{
  id: 70,
  name: "Baku",
  slug:"baku",
  country: "Azerbaijan",
  desc: "Modern flames rising from ancient roots.",
  image: "https://plus.unsplash.com/premium_photo-1731443614667-e924b1d926fe?w=1000&auto=format&fit=crop&q=60&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxzZWFyY2h8NXx8YmFrdXxlbnwwfHwwfHx8MA%3D%3D",
},
{
  id: 71,
  name: "Doha",
  slug:"doha",
  country: "Qatar",
  desc: "A fast-rising Gulf city blending tradition and modernity.",
  image: "https://images.unsplash.com/photo-1669300884869-e6e11c67c031?w=1000&auto=format&fit=crop&q=60&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxzZWFyY2h8OHx8ZG9oYXxlbnwwfHwwfHx8MA%3D%3D",
},
{
  id: 72,
  name: "Riyadh",
  slug:"riyadh",
  country: "Saudi Arabia",
  desc: "The heart of Saudi Arabia’s cultural and economic transformation.",
  image: "https://images.unsplash.com/photo-1605237165959-dcc784975d51?w=1000&auto=format&fit=crop&q=60&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxzZWFyY2h8MTJ8fHJpeWFkaHxlbnwwfHwwfHx8MA%3D%3D",
},
{
  id: 73,
  name: "Jerusalem",
  slug:"jerusalem",
  country: "Israel",
  desc: "One of the world’s oldest and most spiritual cities.",
  image: "https://plus.unsplash.com/premium_photo-1675369532333-a32de6c1e55e?w=1000&auto=format&fit=crop&q=60&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxzZWFyY2h8NXx8amVydXNhbGVtfGVufDB8fDB8fHww",
},
{
  id: 74,
  name: "Tehran",
  slug:"tehran",
  country: "Iran",
  desc: "A historic metropolis framed by the Alborz mountains.",
  image: "https://images.unsplash.com/photo-1615373615964-389b41cda0a7?w=1000&auto=format&fit=crop&q=60&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxzZWFyY2h8MjB8fHRlaHJhbnxlbnwwfHwwfHx8MA%3D%3D",
},
{
  id: 75,
  name: "Almaty",
  slug:"almaty",
  country: "Kazakhstan",
  desc: "A leafy city surrounded by dramatic mountain scenery.",
  image: "https://images.unsplash.com/photo-1600255531849-9edcc7c3d115?w=1000&auto=format&fit=crop&q=60&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxzZWFyY2h8NHx8YWxtYXR5fGVufDB8fDB8fHww",
},
{
  id: 76,
  name: "Yerevan",
  slug:"yerevan",
  country: "Armenia",
  desc: "Ancient culture with views of Mount Ararat.",
  image: "https://plus.unsplash.com/premium_photo-1661934402599-7cb20c105a7b?w=1000&auto=format&fit=crop&q=60&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxzZWFyY2h8MXx8eWVyZXZhbnxlbnwwfHwwfHx8MA%3D%3D",
},
{
  id: 77,
  name: "Tbilisi",
  slug:"tbilisi",
  country: "Georgia",
  desc: "Colorful balconies, sulfur baths, and wine culture.",
  image: "https://plus.unsplash.com/premium_photo-1677344088109-8122ab4e2a5b?w=1000&auto=format&fit=crop&q=60&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxzZWFyY2h8MXx8dGJpbGlzaXxlbnwwfHwwfHx8MA%3D%3D",
},
{
  id: 78,
  name: "Sarajevo",
  slug:"sarajevo",
  country: "Bosnia and Herzegovina",
  desc: "A city where East and West deeply intertwine.",
  image: "https://images.unsplash.com/photo-1570831709673-03320e9d734f?w=1000&auto=format&fit=crop&q=60&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxzZWFyY2h8Mnx8c2FyYWpldm98ZW58MHx8MHx8fDA%3D",
},
{
  id: 79,
  name: "Belgrade",
  slug:"belgrade",
  country: "Serbia",
  desc: "A lively Balkan capital at the confluence of two rivers.",
  image: "https://images.unsplash.com/photo-1727105538592-3074729d8abc?w=1000&auto=format&fit=crop&q=60&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxzZWFyY2h8M3x8YmVsZ3JhZGV8ZW58MHx8MHx8fDA%3D",
},
{
  id: 80,
  name: "Sofia",
  slug:"sofia",
  country: "Bulgaria",
  desc: "Ancient ruins beneath a modern European city.",
  image: "https://images.unsplash.com/photo-1695798598638-e8305f0ffac2?w=1000&auto=format&fit=crop&q=60&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxzZWFyY2h8N3x8c29maWF8ZW58MHx8MHx8fDA%3D",
},
{
  id: 81,
  name: "Bucharest",
  slug:"bucharest",
  country: "Romania",
  desc: "A mix of grand boulevards and old-world charm.",
  image: "https://images.unsplash.com/photo-1574616979112-f9f52d3747f8?w=1000&auto=format&fit=crop&q=60&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxzZWFyY2h8Mnx8YnVjaGFyZXN0fGVufDB8fDB8fHww",
},
{
  id: 82,
  name: "Skopje",
  slug:"skopje",
  country: "North Macedonia",
  desc: "Statues, bridges, and Balkan heritage.",
  image: "https://images.unsplash.com/photo-1624895060572-a5fc35b5db2f?w=1000&auto=format&fit=crop&q=60&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxzZWFyY2h8NHx8c2tvcGplfGVufDB8fDB8fHww",
},
{
  id: 83,
  name: "Ljubljana",
  slug:"ljubljana",
  country: "Slovenia",
  desc: "A green, charming capital with a fairytale old town.",
  image: "https://images.unsplash.com/photo-1611576191056-3e6696029388?w=1000&auto=format&fit=crop&q=60&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxzZWFyY2h8Mnx8bGp1YmxqYW5hfGVufDB8fDB8fHww",
},
{
  id: 84,
  name: "Monaco",
  slug:"monaco",
  country: "Monaco",
  desc: "Luxury, yachts, and Mediterranean glamour.",
  image: "https://images.unsplash.com/photo-1595138320174-a64d168e9970?w=1000&auto=format&fit=crop&q=60&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxzZWFyY2h8Mnx8bW9uYWNvfGVufDB8fDB8fHww",
},
{
  id: 85,
  name: "Nice",
  slug:"nice",
  country: "France",
  desc: "Azure coastlines and relaxed Riviera vibes.",
  image: "https://images.unsplash.com/photo-1604440401661-8f6f07c285a2?w=1000&auto=format&fit=crop&q=60&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxzZWFyY2h8N3x8bmljZXxlbnwwfHwwfHx8MA%3D%3D",
},
{
  id: 86,
  name: "Naples",
  slug:"naples",
  country: "Italy",
  desc: "Historic streets beneath Mount Vesuvius.",
  image: "https://images.unsplash.com/photo-1527208043690-e3db1cc93456?w=1000&auto=format&fit=crop&q=60&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxzZWFyY2h8Nnx8bmFwbGVzfGVufDB8fDB8fHww",
},
{
  id: 87,
  name: "Palermo",
  slug:"palermo",
  country: "Italy",
  desc: "A crossroads of Mediterranean civilizations.",
  image: "https://images.unsplash.com/photo-1586729223498-2cc4a05d3858?w=1000&auto=format&fit=crop&q=60&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxzZWFyY2h8Mnx8cGFsZXJtb3xlbnwwfHwwfHx8MA%3D%3D",
},
{
  id: 88,
  name: "Valletta",
  slug:"valletta",
  country: "Malta",
  desc: "A fortified city rich in maritime history.",
  image: "https://plus.unsplash.com/premium_photo-1673561231809-17f6f9ef09b7?w=1000&auto=format&fit=crop&q=60&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxzZWFyY2h8MXx8dmFsbGV0dGF8ZW58MHx8MHx8fDA%3D",
},
{
  id: 89,
  name: "Lima",
  slug: "lima",
  country: "Peru",
  desc: "Clifftop views and world-famous cuisine.",
  image: "https://images.unsplash.com/photo-1580530719837-952e0515b69a?w=1000&auto=format&fit=crop&q=60"
},
{
  id: 90,
  name: "Bogotá",
  slug: "bogota",
  country: "Colombia",
  desc: "A high-altitude capital full of culture and art.",
  image: "https://plus.unsplash.com/premium_photo-1697730030651-3a7aa391b9d6?w=1000&auto=format&fit=crop&q=60"
},
{
  id: 91,
  name: "Quito",
  slug: "quito",
  country: "Ecuador",
  desc: "A beautifully preserved old town near the equator.",
  image: "https://images.unsplash.com/photo-1610226977124-9fd2755d09f2?w=1000&auto=format&fit=crop&q=60"
},
{
  id: 92,
  name: "La Paz",
  slug: "la-paz",
  country: "Bolivia",
  desc: "The world’s highest capital city.",
  image: "https://images.unsplash.com/photo-1650700311346-dd9ad9e77114?w=1000&auto=format&fit=crop&q=60"
},
{
  id: 93,
  name: "Casablanca",
  slug: "casablanca",
  country: "Morocco",
  desc: "Modern energy mixed with Atlantic heritage.",
  image: "https://images.unsplash.com/photo-1528657249085-c569d3c869e4?w=1000&auto=format&fit=crop&q=60"
},
{
  id: 94,
  name: "Addis Ababa",
  slug: "addis-ababa",
  country: "Ethiopia",
  desc: "Political heart of Africa with ancient roots.",
  image: "https://images.unsplash.com/photo-1664022379391-8b52fd2653f0?w=1000&auto=format&fit=crop&q=60"
},
{
  id: 95,
  name: "Nairobi",
  slug: "nairobi",
  country: "Kenya",
  desc: "A safari city where wildlife meets skyscrapers.",
  image: "https://images.unsplash.com/photo-1635595358293-03620e36be48?w=1000&auto=format&fit=crop&q=60"
},
{
  id: 96,
  name: "Matera",
  slug: "matera",
  country: "Italy",
  desc: "Ancient cave dwellings carved into limestone cliffs.",
  image: "https://images.unsplash.com/photo-1596319682968-c8d4875a6f17?w=1000&auto=format&fit=crop&q=60"
},
{
  id: 97,
  name: "Kotor",
  slug: "kotor",
  country: "Montenegro",
  desc: "A medieval town tucked deep inside a dramatic bay.",
  image: "https://images.unsplash.com/photo-1544329095-a7c19df83018?w=1000&auto=format&fit=crop&q=60"
},
{
  id: 98,
  name: "Mostar",
  slug: "mostar",
  country: "Bosnia and Herzegovina",
  desc: "Iconic bridge, Ottoman heritage, and river views.",
  image: ""
},
{
  id: 99,
  name: "Ohrid",
  slug: "ohrid",
  country: "North Macedonia",
  desc: "Lakeside churches and quiet old-town charm.",
  image: "https://images.unsplash.com/photo-1618735751653-d221b2436b0e?w=1000&auto=format&fit=crop&q=60"
},
{
  id: 100,
  name: "Gjirokastër",
  slug: "gjirokaster",
  country: "Albania",
  desc: "Stone houses and hilltop castle views.",
  image: "https://plus.unsplash.com/premium_photo-1736063854328-48347237635a?w=1000&auto=format&fit=crop&q=60"
},
{
  id: 101,
  name: "Plovdiv",
  slug: "plovdiv",
  country: "Bulgaria",
  desc: "One of Europe’s oldest cities with Roman ruins.",
  image: "https://images.unsplash.com/photo-1672691993652-c0dc435011cc?w=1000&auto=format&fit=crop&q=60"
},
{
  id: 102,
  name: "Brasov",
  slug: "brasov",
  country: "Romania",
  desc: "A Transylvanian town surrounded by the Carpathians.",
  image: "https://images.unsplash.com/photo-1558253347-fb1128610003?w=1000&auto=format&fit=crop&q=60"
},
{
  id: 103,
  name: "Český Krumlov",
  slug: "cesky-krumlov",
  country: "Czech Republic",
  desc: "A fairytale town frozen in medieval time.",
  image: "https://plus.unsplash.com/premium_photo-1661963139522-22525f644234?w=1000&auto=format&fit=crop&q=60"
},
{
  id: 104,
  name: "Lviv",
  slug: "lviv",
  country: "Ukraine",
  desc: "Coffee culture, cobbled streets, and Austro-Hungarian vibes.",
  image: "https://images.unsplash.com/photo-1572940252238-edf9d51925ba?w=1000&auto=format&fit=crop&q=60"
},
{
  id: 105,
  name: "Salzburg",
  slug: "salzburg",
  country: "Austria",
  desc: "Baroque beauty and alpine surroundings.",
  image: "https://plus.unsplash.com/premium_photo-1661962627529-73e5d332d04a?q=80&w=1170&auto=format&fit=crop"
},
{
  id: 106,
  name: "Hallstatt",
  slug: "hallstatt",
  country: "Austria",
  desc: "A postcard village by a serene alpine lake.",
  image: "https://images.unsplash.com/photo-1601801017546-1dd109433165?w=1000&auto=format&fit=crop&q=60"
},
{
  id: 107,
  name: "Tromsø",
  slug: "tromso",
  country: "Norway",
  desc: "Arctic city famous for northern lights.",
  image: "https://images.unsplash.com/photo-1560185678-759b5712a60e?w=1000&auto=format&fit=crop&q=60"
},
{
  id: 108,
  name: "Faroe Islands",
  slug: "faroe-islands",
  country: "Denmark",
  desc: "Remote cliffs, waterfalls, and dramatic landscapes.",
  image: "https://images.unsplash.com/photo-1561810051-09dd8d26010c?w=1000&auto=format&fit=crop&q=60"
},
{
  id: 109,
  name: "Svaneti",
  slug: "svaneti",
  country: "Georgia",
  desc: "Ancient stone towers in the Caucasus mountains.",
  image: "https://images.unsplash.com/photo-1569498283068-140e58143192?w=1000&auto=format&fit=crop&q=60"
},
{
  id: 110,
  name: "Luang Prabang",
  slug: "luang-prabang",
  country: "Laos",
  desc: "Monks, waterfalls, and slow riverside life.",
  image: "https://plus.unsplash.com/premium_photo-1661882477461-20d16af70819?w=1000&auto=format&fit=crop&q=60"
},
{
  id: 111,
  name: "Hpa-An",
  slug: "hpa-an",
  country: "Myanmar",
  desc: "Limestone caves and quiet countryside.",
  image: "https://images.unsplash.com/photo-1583844497208-780ced06a8c2?w=1000&auto=format&fit=crop&q=60"
},
{
  id: 112,
  name: "Sapa",
  slug: "sapa",
  country: "Vietnam",
  desc: "Terraced rice fields and misty mountains.",
  image: "https://images.unsplash.com/photo-1694152363060-cc26bde73872?w=1000&auto=format&fit=crop&q=60"
},
{
  id: 113,
  name: "Ninh Binh",
  slug: "ninh-binh",
  country: "Vietnam",
  desc: "River landscapes known as “Halong Bay on land”.",
  image: "https://images.unsplash.com/photo-1560550356-3cdd74bca5e8?w=1000&auto=format&fit=crop&q=60"
},
{
  id: 114,
  name: "Siwa Oasis",
  slug: "siwa-oasis",
  country: "Egypt",
  desc: "Remote desert oasis with Berber culture.",
  image: "https://images.unsplash.com/photo-1527736848781-72dc3b2ee00f?w=1000&auto=format&fit=crop&q=60"
},
{
  id: 115,
  name: "Chefchaouen",
  slug: "chefchaouen",
  country: "Morocco",
  desc: "A tranquil blue-painted mountain town.",
  image: "https://images.unsplash.com/photo-1569383746724-6f1b882b8f46?w=1000&auto=format&fit=crop&q=60"
},
{
  id: 116,
  name: "Lalibela",
  slug: "lalibela",
  country: "Ethiopia",
  desc: "Rock-hewn churches carved from solid stone.",
  image: "https://images.unsplash.com/photo-1572888195250-3037a59d3578?w=1000&auto=format&fit=crop&q=60"
},
{
  id: 117,
  name: "San Pedro de Atacama",
  slug: "san-pedro-de-atacama",
  country: "Chile",
  desc: "Mars-like desert landscapes and starry skies.",
  image: "https://images.unsplash.com/photo-1556741495-4a9f3c6935e8?w=1000&auto=format&fit=crop&q=60"
},
{
  id: 118,
  name: "Uyuni",
  slug: "uyuni",
  country: "Bolivia",
  desc: "Gateway to the world’s largest salt flats.",
  image: "https://images.unsplash.com/photo-1517706598116-51e85d33db24?w=1000&auto=format&fit=crop&q=60"
},
{
  id: 119,
  name: "Pucón",
  slug: "pucon",
  country: "Chile",
  desc: "Adventure town beneath an active volcano.",
  image: "https://images.unsplash.com/photo-1665107277506-5f272d52ddb1?w=1000&auto=format&fit=crop&q=60"
},
{
  id: 120,
  name: "Tasmania",
  slug: "tasmania",
  country: "Australia",
  desc: "Wild coastlines, forests, and untouched nature.",
  image: "https://images.unsplash.com/photo-1617766643842-bb3fc12dffc8?w=1000&auto=format&fit=crop&q=60"
}



];
